import axios, { AxiosRequestConfig } from 'axios'

import { InputFileType } from './get-url-to-upload-file'

export const uploadFile = async (
  data: {
    url: string
    file: File | Blob
    originalFilename: string
    demandId: string
    type: InputFileType
  },
  options?: AxiosRequestConfig,
) => {
  return axios.put(data.url, data.file, {
    ...options,
    headers: {
      'Content-Type': 'application/octet-stream',
      'Content-Disposition': `attachment;filename="${data.originalFilename}"`,
    },
  })
}
